import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MemberPickerComponent } from '@sbe-spinoff-schoolbell-e/member-picker';

// 라우팅을 안 쓴다 — EmbedViewController(schoolbell-e-api)가 만드는 부트스트랩 HTML은 <base
// href> 없이 이 앱의 <app-root>만 심고, 실제 브라우저 URL도 이 앱의 라우트가 아니라
// schoolbell-e-api의 `embed/member-picker` 경로다(임베드 진입 문서는 API가 서빙하고, 이
// 앱은 정적 자산만 제공 — 2026-08-20-member-picker-iframe-embed.md). Angular Router로
// 경로를 매칭하려던 첫 시도는 이 불일치 때문에 라우트 매칭 실패로 빈 화면이 됐다(실제 e2e
// 검증 중 발견) — 이 앱의 유일한 기능이 멤버 피커뿐인 동안은 그냥 직접 렌더한다. 두 번째
// 임베드 기능이 생기면 그때 라우팅 방식을 다시 설계한다.
@Component({
  selector: 'app-root',
  imports: [MemberPickerComponent],
  template: '<app-member-picker />',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {}
